const e=e=>"user"!==e?.role&&"prospect"!==e?.role&&"client"!==e?.role,r=e=>"user"===e?.role||"prospect"===e?.role||"client"===e?.role;export{e as isAdvisorType,r as isClientType};
